import AssetPage from './AssetPage';

export default AssetPage;
